import PageWorking from '@pages/page-working.js';

const Faq = (props) => {


    return (
        <>
            <PageWorking />
        </>
    );
}  
export default Faq;